/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestEstimateDto } from '../../models/contents-request-estimate-dto';

export interface ContentsRequestEstimateControllerFindByContentsRequestId$Params {
  id: string;
}

export function contentsRequestEstimateControllerFindByContentsRequestId(http: HttpClient, rootUrl: string, params: ContentsRequestEstimateControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestEstimateDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestEstimateControllerFindByContentsRequestId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestEstimateDto>;
    })
  );
}

contentsRequestEstimateControllerFindByContentsRequestId.PATH = '/api/contents-request-estimate/{id}/contentsRequest';
